<!-- @format -->
<template>
    <div class="columns">
        <div class="column">
            <p>
                <span class="has-text-weight-bold">Poster: </span>
                <span v-if="post.user && post.user.email">{{ post.user.email }}</span>
                <span v-else>(user email unknown)</span>
                <span v-if="post.user && post.user.id">({{ post.user.id }})</span>
                <span v-else>(user id unknown)</span>
            </p>
            <p>
                <span class="has-text-weight-bold">Creation Date:</span>
                {{ formatStandardDateTime(post.created_at, 'basic-detail') }}
            </p>
            <p>
                <span class="has-text-weight-bold">Last Updated:</span>
                {{ formatStandardDateTime(post.updated_at, 'basic-detail') }}
            </p>
            <p><span class="has-text-weight-bold">Status:</span> {{ post.post_status.value }}</p>
            <p v-if="post.post_identifiers && post.post_identifiers.length">
                <span class="has-text-weight-bold">ShortCode:</span>
                {{ describePostIdentifiers(post.post_identifiers) }}
            </p>
            <p v-if="post.post_identifiers && post.post_identifiers.length">{{ post.directLink }}</p>
            <p v-if="post.post_identifiers && post.post_identifiers.length">{{ post.directLinkShort }}</p>

            <template v-if="isPostType(post, ['postTypePoll'])">
                <p class="my-4">Post is a Poll: <a @click="showPollResults(post)"><fa-icon icon="chart-bar" /> View Poll Results</a></p>
            </template>

            <tag-editor :post="post" />
        
            <!-- Poll Results Modal -->
            <poll-results-modal 
                :is-active="showPollResultsModal" 
                :post="post" 
                @close="closePollResultsModal"
            />
        </div>
    </div>
</template>

<script>
import { dateMixin } from '@/mixins/DateMixin.js';
import { postMixin } from '@/mixins/PostMixin.js';
import TagEditor from './Tag/Index.vue';
import PollResultsModal from '@/components/Admin/Posts/List/PollResultsModal.vue';

export default {
    components: {
        PollResultsModal,
        TagEditor
    },

    mixins: [dateMixin, postMixin],

    data() {
        return {
            showPollResultsModal: false
        };
    },

    props: {
        post: {
            type: Object,
            required: true
        }
    },

    methods: {
        showPollResults() {
            this.showPollResultsModal = true;
        },

        closePollResultsModal() {
            this.showPollResultsModal = false;
        }
    },
};
</script>
